var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"flex items-center justify-center gap-2 px-4 py-3 text-base text-white/80 transition-colors hover:text-white md:px-3 md:py-2 md:text-sm",attrs:{"to":_vm.$i18nRoute({ name: 'dashboard' })}},[_c('i',{staticClass:"hf hf-dashboard hf-fw hf-lg"}),_vm._v(" "+_vm._s(_vm.$t('components.top_nav.dashboard'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }